import { normalizeCouponCode } from "@/lib/pending-coupon"
import type { WonPrize } from "./api"
import { prizeGameKind } from "./prize-game"

/** Where a prize came from, as a cart or order line names it. */
export function prizeOrigin(gameType: string): string {
  return prizeGameKind(gameType) === "wheel" ? "Prêmio da roleta" : "Prêmio da raspadinha"
}

/** "Válido até 29/10, às 18:00" in the store's zone, or null when the instant is missing or invalid. */
export function prizeValidity(expiresAt: string | null | undefined, timeZone: string): string | null {
  const at = expiresAt ? new Date(expiresAt) : null
  if (!at || Number.isNaN(at.getTime())) return null
  const parts = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZone }).formatToParts(at)
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((entry) => entry.type === type)?.value ?? ""
  return `Válido até ${part("day")}/${part("month")}, às ${part("hour")}:${part("minute")}`
}

/** Whether the prize's code lifetime is over at `now`. */
export function prizeExpired(prize: Pick<WonPrize, "expiresAt">, now: Date): boolean {
  const at = Date.parse(prize.expiresAt)
  return Number.isFinite(at) && at <= now.getTime()
}

/** The won prize a coupon code belongs to, if it is one. */
export function prizeForCode(prizes: readonly WonPrize[], code: string): WonPrize | undefined {
  const wanted = normalizeCouponCode(code)
  return wanted ? prizes.find((prize) => normalizeCouponCode(prize.code) === wanted) : undefined
}
